export const dynamicPeriodTypes = [
  "TODAY",
  "YESTERDAY",
  "TODAY_AND_YESTERDAY",
  "LAST_3_DAYS",
  "LAST_7_DAYS",
  "LAST_14_DAYS",
  "LAST_28_DAYS",
  "LAST_30_DAYS",
  "LAST_60_DAYS",
  "MONTH_TO_DATE",
  "LAST_MONTH",
  "THIS_WEEK",
  "LAST_WEEK",
  "THIS_WEEK_AND_LAST_WEEK",
  "LAST_3_WEEKS",
  "LAST_4_WEEKS",
  "LAST_7_WEEKS",
  "LAST_12_WEEKS",
  "LAST_14_WEEKS",
  "LAST_26_WEEKS",
  "LAST_28_WEEKS",
  "LAST_52_WEEKS",
  "THIS_MONTH",
  "THIS_MONTH_AND_LAST_MONTH",
  "LAST_3_MONTHS",
  "LAST_6_MONTHS",
  "LAST_9_MONTHS",
  "LAST_12_MONTHS",
  "YEAR_TO_DATE",
  "LAST_YEAR",
  "LAST_3_YEARS",
  "LAST_5_YEARS",
] as const;

export type DynamicPeriodType = (typeof dynamicPeriodTypes)[number];

export type FixedPeriodType = "FIXED";

export type PeriodType = DynamicPeriodType | FixedPeriodType;

export type DynamicPeriod = {
  type: DynamicPeriodType;
};

export type FixedPeriod = {
  type: FixedPeriodType;
  startDate: Date;
  endDate: Date;
};
